import { d as h } from "./index.es26.js";
import { n as p } from "./index.es40.js";
import { e as l } from "./index.es41.js";
var o = h, s = /\s+/g, c = p, d = l;
function i(t, e, n) {
  typeof t == "object" ? (n = e, e = t, t = null) : typeof e == "function" && (n = e, e = r), this._callback = t, this._options = e || r, this._elementCB = n, this.dom = [], this._done = !1, this._tagStack = [], this._parser = this._parser || null;
}
var r = {
  normalizeWhitespace: !1,
  //Replace all whitespace with single spaces
  withStartIndices: !1,
  //Add startIndex properties to nodes
  withEndIndices: !1
  //Add endIndex properties to nodes
};
i.prototype.onparserinit = function(t) {
  this._parser = t;
};
i.prototype.onreset = function() {
  i.call(this, this._callback, this._options, this._elementCB);
};
i.prototype.onend = function() {
  this._done || (this._done = !0, this._parser = null, this._handleCallback(null));
};
i.prototype._handleCallback = i.prototype.onerror = function(t) {
  if (typeof this._callback == "function")
    this._callback(t, this.dom);
  else if (t) throw t;
};
i.prototype.onclosetag = function() {
  var t = this._tagStack.pop();
  this._options.withEndIndices && t && (t.endIndex = this._parser.endIndex), this._elementCB && this._elementCB(t);
};
i.prototype._createDomElement = function(t) {
  if (!this._options.withDomLvl1) return t;
  var e;
  t.type === "tag" ? e = Object.create(d) : e = Object.create(c);
  for (var n in t)
    t.hasOwnProperty(n) && (e[n] = t[n]);
  return e;
};
i.prototype._addDomElement = function(t) {
  var e = this._tagStack[this._tagStack.length - 1], n = e ? e.children : this.dom, a = n[n.length - 1];
  t.next = null, this._options.withStartIndices && (t.startIndex = this._parser.startIndex), this._options.withEndIndices && (t.endIndex = this._parser.endIndex), a ? (t.prev = a, a.next = t) : t.prev = null, n.push(t), t.parent = e || null;
};
i.prototype.onopentag = function(t, e) {
  var n = {
    type: t === "script" ? o.Script : t === "style" ? o.Style : o.Tag,
    name: t,
    attribs: e,
    children: []
  }, a = this._createDomElement(n);
  this._addDomElement(a), this._tagStack.push(a);
};
i.prototype.ontext = function(t) {
  var e = this._options.normalizeWhitespace || this._options.ignoreWhitespace, n;
  if (!this._tagStack.length && this.dom.length && (n = this.dom[this.dom.length - 1]).type === o.Text)
    e ? n.data = (n.data + t).replace(s, " ") : n.data += t;
  else if (this._tagStack.length && (n = this._tagStack[this._tagStack.length - 1]) && (n = n.children[n.children.length - 1]) && n.type === o.Text)
    e ? n.data = (n.data + t).replace(s, " ") : n.data += t;
  else {
    e && (t = t.replace(s, " "));
    var a = this._createDomElement({
      data: t,
      type: o.Text
    });
    this._addDomElement(a);
  }
};
i.prototype.oncomment = function(t) {
  var e = this._tagStack[this._tagStack.length - 1];
  if (e && e.type === o.Comment) {
    e.data += t;
    return;
  }
  var n = {
    data: t,
    type: o.Comment
  }, a = this._createDomElement(n);
  this._addDomElement(a), this._tagStack.push(a);
};
i.prototype.oncdatastart = function() {
  var t = {
    children: [{
      data: "",
      type: o.Text
    }],
    type: o.CDATA
  }, e = this._createDomElement(t);
  this._addDomElement(e), this._tagStack.push(e);
};
i.prototype.oncommentend = i.prototype.oncdataend = function() {
  this._tagStack.pop();
};
i.prototype.onprocessinginstruction = function(t, e) {
  var n = this._createDomElement({
    name: t,
    data: e,
    type: o.Directive
  });
  this._addDomElement(n);
};
var u = i;
export {
  u as d
};
//# sourceMappingURL=index.es24.js.map
